import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { space } from "../../tokens/space";
import { breakpoints, containerWidth } from "../../tokens/size";
const getContainerStyles = (maxWidth) => {
    return {
        boxSizing: 'border-box',
        width: '100%',
        display: 'grid',
        gridTemplateColumns: `minmax(${space.containerOuterPaddingLarge}, 1fr) minmax(0, ${maxWidth}px) minmax(${space.containerOuterPaddingLarge}, 1fr)`,
        [`@media (max-width: ${breakpoints.md})`]: {
            gridTemplateColumns: `minmax(${space.containerOuterPadding}, 1fr) minmax(0, ${maxWidth}px) minmax(${space.containerOuterPadding}, 1fr)`,
        },
        '& > *': {
            gridColumn: 2,
        },
    };
};
function Container({ children, className, maxWidth = containerWidth.md, component, ref, ...other }) {
    const Component = component || 'div';
    const numericMaxWidth = typeof maxWidth === 'string' ? parseInt(maxWidth) : maxWidth;
    return (_jsx(Component, { ref: ref, css: getContainerStyles(numericMaxWidth), className: className, ...other, children: children }));
}
/**
 * A component used to center content with padding and max-width
 */
export { Container };
